import { createHead, UnheadProvider } from "@unhead/react/client";
import React from "react";
import ReactDom from "react-dom";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./lib/i18n"; // i18n初期化
import { restoreSwrCache } from "./lib/swr-cache";

// SWR デフォルトキャッシュへ前回セッションのカタログデータを注入する
// （/services の初回描画を即時化。キャッシュが無ければ何もしない）
restoreSwrCache();

// 開発環境でのみ axe-core を有効化（アクセシビリティチェック）
if (import.meta.env.DEV) {
  import("@axe-core/react").then((axe) => {
    axe.default(React, ReactDom, 1000);
  });
}

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

// @unhead/react: 動的メタタグ注入の head インスタンス
const head = createHead();

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <UnheadProvider head={head}>
      <BrowserRouter
        future={{
          // biome-ignore lint/style/useNamingConvention: react-router-dom v6 future フラグの固定プロパティ名
          v7_startTransition: true,
          // biome-ignore lint/style/useNamingConvention: react-router-dom v6 future フラグの固定プロパティ名
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </UnheadProvider>
  </React.StrictMode>,
);
